import type { ReactNode } from 'react';

export type Tone = 'default' | 'good' | 'warn' | 'bad' | 'muted' | 'feature' | 'feature-bf';

const toneClass: Record<Tone, string> = {
  default: 'text-stone-100',
  good: 'text-emerald-400',
  warn: 'text-amber-400',
  bad: 'text-rose-400',
  muted: 'text-stone-500',
  feature: 'text-stone-50',
  'feature-bf': 'text-violet-300',
};

export function Stat({
  label,
  value,
  unit,
  sub,
  tone = 'default',
  size = 'normal',
}: {
  label: string;
  value: ReactNode;
  unit?: string;
  sub?: ReactNode;
  tone?: Tone;
  size?: 'normal' | 'large';
}) {
  const valueClass = size === 'large' ? 'text-5xl' : 'text-3xl';
  return (
    <div className="border-l border-stone-700 pl-4">
      <div className="text-[10px] uppercase tracking-[0.2em] text-stone-500 font-mono mb-1">{label}</div>
      <div className={`${valueClass} font-light tabular-nums ${toneClass[tone]}`}>
        {value}
        {unit && <span className="text-sm text-stone-500 ml-1 font-mono">{unit}</span>}
      </div>
      {sub && <div className="text-xs text-stone-500 font-mono mt-1">{sub}</div>}
    </div>
  );
}
